import getAopsUrl from "./getAopsUrl";
import getLegacyCampusURL from "./getLegacyCampusURL";

const staticUrls = {
	terms: "/legal/terms",
	privacy: "/legal/privacy",
	enrollmentAgreement: "/course-enrollment",
	contact: "/contact-us",
	aopsOnline: getAopsUrl().toString(),
	virtualCampus: getLegacyCampusURL("virtual"),
	beastAcademy: "https://beastacademy.com/", // todo: move to a .env?
	about: "/about",
	admissions: "/",
	tuition: "/tuition",
	classScheduleAY: "/class-schedule?season=academic-year",
	classScheduleSummer: "/class-schedule?season=summer",
	careers: getAopsUrl("careers").toString(),
	academicYear: "/courses/catalog/academic-year",
	location: "/locations",
	thankYou: "/consultation/thank-you",
	signOut: "/sign-out",
	cart: "/cart",
	ayCourses: "/courses/catalog/academic-year",
	summerCourses: "/courses/catalog/summer",
	mathCourses: "/courses/subject/math",
	languageArtsCourses: "/courses/subject/language_arts",
	scienceCourses: "/courses/subject/science",
	computerScienceCourses: "/courses/subject/computer_science",
	summerCamps: "/courses/summer",
};

export default staticUrls;
